import React, {useEffect} from "react";
import Card from "../../../../componets/Card";
import { useAppDispatch } from "../../../../store/hooks";
import { fetchStickers } from "../../../../actions/sticker_maker/stickersActions";
import List from "../../Stickers/_partials/_List";
import { queryParams } from "../../../../helpers/UrlHelpers";
import { useSearchParams } from "react-router-dom";
import ListViewButtons from "../../../../componets/ListViewButtons";

const DEFAULT_VIEW = 'list';

const _Stickers = ({ stickerPackId }: { stickerPackId: any }) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const listType: any   = queryParams.get(searchParams,'view') || DEFAULT_VIEW;

  useEffect(() => {
    if (stickerPackId) {
      dispatch(fetchStickers({ sticker_pack_id: stickerPackId }));
    }
  }, [stickerPackId, dispatch]);

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Stickers</h4>

        <ListViewButtons align='right' defaultType={DEFAULT_VIEW} className='v-mb-10' />

        <div>
          <List limit={100} stickerPackId={stickerPackId} type={listType} />
        </div>
      </Card>
    </>
  );
}

export default _Stickers;
